import React, { Component } from 'react';
import { Button, Col, FormControl, FormGroup, Grid, Modal, Row } from 'react-bootstrap';
import { connect } from 'react-redux';
import { ToastContainer, toast } from 'react-toastify';
import { bindActionCreators } from 'redux';

import { generics } from 'actions';
import { LOGIN } from 'actions/const';

import ic_mobile from '../../assets/image/icn_rwmmobile.png';
import logo from '../../assets/image/logo_rwm-white.png';
import Background from './Background';

class Login extends Component {
	constructor(props) {
		super(props);

		this.state = {
			errors: {},
			showChangePasswordModal: false,
			changePasswordUserId: null,
			changePasswordToken: null,
			newPassword: '',
			confirmPassword: '',
			changePasswordErrors: {},
			isChangingPassword: false,
			showLoginPassword: false,
			showNewPassword: false,
			showConfirmPassword: false,
		};

		this.LogMeIn = this.LogMeIn.bind(this);
		this.logOut = this.logOut.bind(this);
		this.handleChangePassword = this.handleChangePassword.bind(this);
	}

	LogMeIn() {
		let { history } = this.props;
		let { username, password } = this;
		let { setValue } = this.props.actions;

		if (username.value === '') {
			this.setState({
				errors: {
					// ...this.state.errors,
					username: 'Username is required.',
				},
			});
			return;
		}

		if (password.value === '') {
			this.setState({
				errors: {
					// ...this.state.errors,
					password: 'Password is required.',
				},
			});
			return;
		}

		this.setState({
			errors: {},
		});

		setValue(LOGIN, 'isLoggingIn', true);

		window.localStorage.clear();

		Parse.Cloud.run('login', {
			username: username.value,
			password: password.value,
		})
			.then((userData) => {
				var user = new Parse.User();
				user._finishFetch(userData);
				user._setExisted(true);
				return Parse.CoreManager.getUserController().setCurrentUser(user);
			})
			.then((user) => {
				var roleQuery = new Parse.Query(Parse.Role);
				roleQuery.equalTo('name', 'cms');
				roleQuery.include(['users']);

				var _userObj = user;
				return new Promise((res, rej) => {
					roleQuery
						.find()
						.then((data) => {
							var users = data[0];

							let usersRelationQuery = users.relation('users').query();

							usersRelationQuery.equalTo('objectId', _userObj.id);

							return usersRelationQuery.find();
						})
						.then((data) => {
							var isExist = false;

							for (let user of data) {
								if (user.id === _userObj.id) {
									isExist = true;
									break;
								}
							}

							if (isExist) {
								var accessRightQuery = new Parse.Query('AccessRightsWeb');
								accessRightQuery.include([
									'AccessListWeb',
									'AccessListWeb.ModulesWeb',
									'AccessListWeb.Actions',
									'AccessListWeb.Apps',
								]);

								var appsQuery = new Parse.Query('Apps');
								appsQuery.equalTo('name', 'RWM CMS');

								var accessListQuery = new Parse.Query('AccessListWeb');
								accessListQuery.matchesQuery('Apps', appsQuery);

								accessRightQuery.equalTo('User', _userObj);
								accessRightQuery.matchesQuery('AccessListWeb', accessListQuery);

								return new Promise((res, rej) => {
									accessRightQuery
										.count()
										.then((count) => {
											accessRightQuery.limit(count);
											return accessRightQuery.find();
										})
										.then((data) => {
											res(data);
										})
										.catch((err) => {
											rej(err);
										});
								});
							}
							res(isExist);
						})
						.then((data) => {
							console.log(data);

							var json = this.getJSON(data);
							console.log('access: ', json);

							localStorage.setItem('rights', JSON.stringify(json));
							res(true);
						})
						.catch((err) => {
							console.log(err);
							rej(err);
						});
				});
			})
			.then((exist) => {
				setValue(LOGIN, 'isLoggingIn', false);
				if (exist) {
					let json = [];
					let rights = localStorage.rights;
					if (typeof rights !== 'undefined') {
						json = JSON.parse(rights);
						if (json.length !== 0) {
							history.push(json[0].route);
						} else {
							alert('This account doesnt have access to this app.');
							this.logOut();
						}
					}
				} else {
					alert('This account doesnt have access to this app.');
					this.logOut();
				}
			})
			.catch((err) => {
				setValue(LOGIN, 'isLoggingIn', false);

				const errData = err && err.message;
				if (errData && errData.reasonCode === 'CHANGE_PASSWORD_REQUIRED') {
					this.setState({
						showChangePasswordModal: true,
						changePasswordUserId: errData.id,
						changePasswordToken: errData.cpToken,
						newPassword: '',
						confirmPassword: '',
						changePasswordErrors: {},
					});
					return;
				}

				toast.error(err.message || 'Login failed. Please try again.');
			});
	}

	getJSON(data) {
		let json = [];
		try {
			data.map((obj) => {
				if (
					typeof obj.get('AccessListWeb').get('ModulesWeb') !== 'undefined' &&
					typeof obj.get('AccessListWeb').get('Actions') !== 'undefined'
				) {
					let moduleId = obj.get('AccessListWeb').get('ModulesWeb').id;
					let module = obj
						.get('AccessListWeb')
						.get('ModulesWeb')
						.get('name')
						.toUpperCase();
					let route = obj.get('AccessListWeb').get('ModulesWeb').get('route');
					let action = obj.get('AccessListWeb').get('Actions').get('name').toUpperCase();
					let actionId = obj.get('AccessListWeb').get('Actions').id;
					let app = obj.get('AccessListWeb').get('Apps').get('name');
					const index = json.map((e) => e.module).indexOf(module);

					if (index == -1) {
						json.push({
							module: module,
							moduleId: moduleId,
							route: route,
							app: app,
							actions: [
								{
									name: action,
									actionId: actionId,
								},
							],
						});
					} else {
						json[index].actions.push({
							name: action,
							actionId: actionId,
						});
					}
				}
			});
			// for (var obj in data) {
			//
			// }
			return json;
		} catch (e) {
			console.log(e);
			return [];
		}
	}

	handleChangePassword() {
		let { newPassword, confirmPassword, changePasswordUserId, changePasswordToken } =
			this.state;

		if (!newPassword) {
			this.setState({ changePasswordErrors: { newPassword: 'New password is required.' } });
			return;
		}

		if (!confirmPassword) {
			this.setState({
				changePasswordErrors: { confirmPassword: 'Please confirm your new password.' },
			});
			return;
		}

		if (newPassword !== confirmPassword) {
			this.setState({ changePasswordErrors: { confirmPassword: 'Passwords do not match.' } });
			return;
		}

		this.setState({ changePasswordErrors: {}, isChangingPassword: true });

		Parse.Cloud.run('changePassword', {
			id: changePasswordUserId,
			cpToken: changePasswordToken,
			newPassword: newPassword,
		})
			.then(() => {
				this.setState({
					showChangePasswordModal: false,
					isChangingPassword: false,
					changePasswordUserId: null,
					changePasswordToken: null,
				});
				toast.success('Password changed successfully. Please log in again.');
				let { history } = this.props;
				history.push('/login');
			})
			.catch((err) => {
				console.error('Change password error: ', err.message);
				this.setState({
					isChangingPassword: false,
					changePasswordErrors: {
						general: err.message || 'Failed to change password. Please try again.',
					},
				});
			});
	}

	logOut() {
		let { history } = this.props;

		Parse.User.logOut()
			.then((data) => {
				localStorage.clear();
				history.push('/login');
			})
			.catch((err) => {
				if (err.code === Parse.Error.INVALID_SESSION_TOKEN) {
					this.logout();
				}
			});
	}
	componentWillMount() {
		// console.log(this.props);
		let { history } = this.props;

		Parse.Session.current()
			.then((data) => {
				// session if valid
				if (Parse.User.current()) {
					history.push('/notification');
				}
			})
			.catch((err) => {
				if (
					err === 'There is no current user.' ||
					err.code === Parse.Error.INVALID_SESSION_TOKEN
				) {
					this.logOut();
				}
			});
	}

	render() {
		// console.log(this.props);
		let {
			errors,
			showChangePasswordModal,
			newPassword,
			confirmPassword,
			changePasswordErrors,
			isChangingPassword,
			showLoginPassword,
			showNewPassword,
			showConfirmPassword,
		} = this.state;
		let { isLoggingIn } = this.props.login;

		const colorRed = {
			color: 'red',
		};

		return (
			<div>
				<Background>
					<img
						src={logo}
						style={{
							margin: '1% 0px 0px 10%',
						}}
					/>
					<Grid>
						<Row
							style={{
								marginTop: '10%',
							}}
						>
							<Col
								md={4}
								style={{
									backgroundColor: 'white',
									padding: '50px 0px 50px 50px',
									height: '207px',
								}}
								mdOffset={2}
							>
								<Col md={2} xs={2} sm={2}>
									<img
										src={ic_mobile}
										style={{
											height: '100px',
										}}
									/>
								</Col>
								<Col
									md={10}
									xs={10}
									sm={10}
									style={{
										height: '100px',
										padding: '30px 0px 0px 30px',
									}}
								>
									<h4
										style={{
											margin: '0px',
										}}
									>
										content management
									</h4>
									<h4
										style={{
											fontWeight: '200',
											margin: '0px',
										}}
									>
										NWR MOBILE APP
									</h4>
								</Col>
							</Col>
							<Col
								md={4}
								style={{
									backgroundColor: 'black',
									padding: '30px 50px 0 50px',
									height: '207px',
								}}
							>
								<form>
									<FormGroup>
										<FormControl
											type="text"
											placeholder="Username"
											style={{
												textAlign: 'center',
											}}
											inputRef={(e) => (this.username = e)}
											onKeyPress={(e) => {
												if (e.key == 'Enter') {
													this.LogMeIn();
												}
											}}
										/>
										<p style={colorRed}>
											<i>
												<i>
													{typeof errors.username !== 'undefined'
														? errors.username
														: ''}
												</i>
											</i>
										</p>
									</FormGroup>
									<FormGroup>
										<div style={{ position: 'relative' }}>
											<FormControl
												type={showLoginPassword ? 'text' : 'password'}
												placeholder="Password"
												style={{
													textAlign: 'center',
													paddingRight: '36px',
												}}
												inputRef={(e) => (this.password = e)}
												onKeyPress={(e) => {
													if (e.key == 'Enter') {
														this.LogMeIn();
													}
												}}
											/>
											<span
												onClick={() =>
													this.setState({
														showLoginPassword: !showLoginPassword,
													})
												}
												style={{
													position: 'absolute',
													right: '10px',
													top: '50%',
													transform: 'translateY(-50%)',
													cursor: 'pointer',
													color: 'white',
												}}
											>
												<i
													className={
														showLoginPassword
															? 'fa fa-eye-slash'
															: 'fa fa-eye'
													}
												/>
											</span>
										</div>
										<p style={colorRed}>
											<i>
												<i>
													{typeof errors.password !== 'undefined'
														? errors.password
														: ''}
												</i>
											</i>
										</p>
									</FormGroup>
									<FormGroup>
										<Button
											bsStyle="danger"
											style={{
												width: '100%',
											}}
											onClick={this.LogMeIn}
										>
											{isLoggingIn ? (
												<span>
													<i
														className="fa fa-spinner fa-spin"
														style={{ color: 'white' }}
													></i>
													&nbsp;LOGGING IN...
												</span>
											) : (
												'LOGIN'
											)}
										</Button>
									</FormGroup>
								</form>
							</Col>
						</Row>
					</Grid>
				</Background>

				<Modal
					show={showChangePasswordModal}
					backdrop="static"
					keyboard={false}
					bsSize="small"
				>
					<Modal.Header>
						<Modal.Title>Change Password Required</Modal.Title>
					</Modal.Header>
					<Modal.Body>
						<p>You must set a new password before continuing.</p>
						<FormGroup>
							<div style={{ position: 'relative' }}>
								<FormControl
									type={showNewPassword ? 'text' : 'password'}
									placeholder="New Password"
									value={newPassword}
									style={{ paddingRight: '36px' }}
									onChange={(e) =>
										this.setState({
											newPassword: e.target.value,
											changePasswordErrors: {},
										})
									}
								/>
								<span
									onClick={() =>
										this.setState({ showNewPassword: !showNewPassword })
									}
									style={{
										position: 'absolute',
										right: '10px',
										top: '50%',
										transform: 'translateY(-50%)',
										cursor: 'pointer',
										color: '#555',
									}}
								>
									<i
										className={
											showNewPassword ? 'fa fa-eye-slash' : 'fa fa-eye'
										}
									/>
								</span>
							</div>
							{changePasswordErrors.newPassword && (
								<p style={{ color: 'red' }}>
									<i>{changePasswordErrors.newPassword}</i>
								</p>
							)}
						</FormGroup>
						<FormGroup>
							<div style={{ position: 'relative' }}>
								<FormControl
									type={showConfirmPassword ? 'text' : 'password'}
									placeholder="Confirm Password"
									value={confirmPassword}
									style={{ paddingRight: '36px' }}
									onChange={(e) =>
										this.setState({
											confirmPassword: e.target.value,
											changePasswordErrors: {},
										})
									}
								/>
								<span
									onClick={() =>
										this.setState({ showConfirmPassword: !showConfirmPassword })
									}
									style={{
										position: 'absolute',
										right: '10px',
										top: '50%',
										transform: 'translateY(-50%)',
										cursor: 'pointer',
										color: '#555',
									}}
								>
									<i
										className={
											showConfirmPassword ? 'fa fa-eye-slash' : 'fa fa-eye'
										}
									/>
								</span>
							</div>
							{changePasswordErrors.confirmPassword && (
								<p style={{ color: 'red' }}>
									<i>{changePasswordErrors.confirmPassword}</i>
								</p>
							)}
						</FormGroup>
						{changePasswordErrors.general && (
							<p style={{ color: 'red' }}>
								<i>{changePasswordErrors.general}</i>
							</p>
						)}
					</Modal.Body>
					<Modal.Footer>
						<Button
							bsStyle="danger"
							onClick={this.handleChangePassword}
							disabled={isChangingPassword}
						>
							{isChangingPassword ? (
								<span>
									<i
										className="fa fa-spinner fa-spin"
										style={{ color: 'white' }}
									></i>
									&nbsp;SAVING...
								</span>
							) : (
								'CHANGE PASSWORD'
							)}
						</Button>
					</Modal.Footer>
				</Modal>
				<ToastContainer position="top-right" autoClose={4000} />
			</div>
		);
	}

	componentDidMount() {
		// console.log(this.props);
	}
}

function mapStateToProps(state) {
	var { login } = state;
	const props = {
		login,
	};
	return props;
}

function mapDispatchToProps(dispatch) {
	const actions = {
		setValue: generics.setValue,
	};
	const actionMap = {
		actions: bindActionCreators(actions, dispatch),
	};
	return actionMap;
}
export default connect(mapStateToProps, mapDispatchToProps)(Login);



// WEBPACK FOOTER //
// ./components/Login/index.js